import { render, staticRenderFns } from "./pf-terminal-filter.vue?vue&type=template&id=18997faa"
import script from "./pf-terminal-filter.vue?vue&type=script&lang=js"
export * from "./pf-terminal-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports